/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { TextField, Grid, InputAdornment, IconButton } from '@mui/material';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import UserImapBranchSelect from './UserImapBranchSelect';
import CustomDialog from '../../../../Components/Dialog/CustomDialog';
import validateEmail from '../../../../Helpers/Validation/validateEmail';

const classes = {
  gridItem: {
    paddingLeft: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
};
const UserImapsDialog = function UserImapsDialog({
  open,
  handleClose,
  onSubmit,
  userImap,
  defaultBranchId,
  defaultBranchDescription,
  title,
  dialogId,
  branches,
}) {
  const intl = useIntl();
  const [formData, setFormData] = useState({
    userId: '00000000-0000-0000-0000-000000000000',
    branchId: defaultBranchId,
    branchDescription: defaultBranchDescription,
    imapUserName: '',
    imapPassword: null,
    imapServerAddress: null,
    frequency: null,
    imapServerPort: null,
    fromAddress: '',
    smtpPassword: null,
    smtpUserName: '',
  });
  const [showPwd, setShowPwd] = useState(true);
  const [showSmtpPwd, setShowSmtpPwd] = useState(true);

  useEffect(() => {
    if (open && dialogId === 'editUserImap') {
      setFormData(userImap);
    }
  }, [open, dialogId, userImap]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectBranch = (selectedBranch) => {
    setFormData((prev) => ({
      ...prev,
      branchId: selectedBranch.id,
      branchDescription: selectedBranch.description,
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  const reset = () => {
    setFormData({
      userId: '00000000-0000-0000-0000-000000000000',
      branchId: defaultBranchId,
      branchDescription: defaultBranchDescription,
      imapUserName: '',
      imapPassword: null,
      imapServerAddress: null,
      frequency: null,
      imapServerPort: null,
      fromAddress: '',
      smtpPassword: null,
      smtpUserName: '',
    });
    setShowPwd(true);
    setShowSmtpPwd(true);
  };

  return (
    <CustomDialog
      title={title}
      open={open}
      close={(_, reason) => {
        if (reason !== 'clickaway' && reason !== 'escapeKeyDown') {
          handleClose();
          reset();
        }
      }}
      disableEscapeKeyDown
      notRequiredFields
      messageDialog
      maxWidth="sm"
      fullWidth
      onSubmit={() => {
        handleSubmit();
        reset();
      }}
      submitDisabled={
        !formData.imapUserName ||
        !formData.imapPassword ||
        !formData.imapServerAddress ||
        !formData.frequency ||
        !formData.imapServerPort ||
        !formData.fromAddress ||
        !formData.smtpPassword ||
        !formData.smtpUserName
      }
      noBackdrop
      noForm
    >
      <Grid
        container
        rowSpacing="18px"
        columnSpacing="16px"
        sx={{ width: '100%', height: '100%' }}
      >
        {dialogId !== 'editUserImap' && (
          <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
            <UserImapBranchSelect
              handleChangeBranch={handleSelectBranch}
              branches={branches}
            />
          </Grid>
        )}
        <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
          <TextField
            id="imapUserName"
            label={intl.messages.IMAP_USERNAME}
            required
            fullWidth
            value={formData.imapUserName}
            onChange={handleChange}
            name="imapUserName"
          />
        </Grid>
        <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
          <TextField
            id="imapPassword"
            label={intl.messages.IMAP_PASSWORD}
            required
            fullWidth
            value={formData.imapPassword}
            onChange={handleChange}
            name="imapPassword"
            type={!showPwd ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPwd(!showPwd)}
                    edge="end"
                    tabIndex={-1}
                  >
                    {!showPwd ? (
                      <VisibilityOff sx={{ color: 'inherit' }} />
                    ) : (
                      <Visibility sx={{ color: 'inherit' }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
          <TextField
            id="imapServerAddress"
            label={intl.messages.IMAP_SERVERADDRESS}
            required
            fullWidth
            value={formData.imapServerAddress}
            onChange={handleChange}
            name="imapServerAddress"
          />
        </Grid>
        <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
          <TextField
            id="frequency"
            label={intl.messages.FREQUENCY}
            required
            fullWidth
            value={formData.frequency}
            onChange={handleChange}
            name="frequency"
            type="number"
          />
        </Grid>
        <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
          <TextField
            id="imapServerPort"
            label={intl.messages.IMAP_SERVERPORT}
            required
            fullWidth
            value={formData.imapServerPort}
            onChange={handleChange}
            name="imapServerPort"
            type="number"
          />
        </Grid>
        <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
          <TextField
            id="fromAddress"
            label={intl.messages.FROMADDRESS}
            required
            fullWidth
            value={formData.fromAddress}
            onChange={handleChange}
            name="fromAddress"
            error={!validateEmail(formData.fromAddress)}
            helperText={
              !validateEmail(formData.fromAddress)
                ? intl.messages.INVALID_EMAIL_ADDRESS
                : ''
            }
          />
        </Grid>
        <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
          <TextField
            id="smtpPassword"
            label={intl.messages.SMTP_PASSWORD}
            required
            fullWidth
            value={formData.smtpPassword}
            onChange={handleChange}
            name="smtpPassword"
            type={!showSmtpPwd ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowSmtpPwd(!showSmtpPwd)}
                    edge="end"
                    tabIndex={-1}
                  >
                    {!showSmtpPwd ? (
                      <VisibilityOff sx={{ color: 'inherit' }} />
                    ) : (
                      <Visibility sx={{ color: 'inherit' }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid size={{ md: 6, sm: 6, xs: 6 }} sx={classes.gridItem}>
          <TextField
            id="smtpUserName"
            label={intl.messages.SMTP_USERNAME}
            required
            fullWidth
            value={formData.smtpUserName}
            onChange={handleChange}
            name="smtpUserName"
            error={!validateEmail(formData.smtpUserName)}
            helperText={
              !validateEmail(formData.smtpUserName)
                ? intl.messages.INVALID_EMAIL_ADDRESS
                : ''
            }
          />
        </Grid>
      </Grid>
    </CustomDialog>
  );
};

UserImapsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  userImap: PropTypes.object.isRequired,
  defaultBranchId: PropTypes.string,
  defaultBranchDescription: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.func.isRequired,
  dialogId: PropTypes.string.isRequired,
  branches: PropTypes.array.isRequired,
};

export default UserImapsDialog;
